module.exports = __webpack_public_path__ + "img/20210729.77793c95.gif";